<template class="pendencyBody">
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-container fluid>
        <b-row>
          <b-col md="3">
            <h5 class="page-title mb-2">
              <b> {{ $route.name }} </b>
            </h5>
          </b-col>
          <b-navbar-nav>
            <b-nav-form>
              <b-button-group size="sm" class="m2-1 text-right mb-1">
                <b-button @click="goBack" size="xxl" variant="light">
                  <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
                </b-button>
              </b-button-group>
              <Filter-Agency-Modal />
              <FilterCBModal />
              <b-button
               style="font-size: 0.675rem;margin-left:5px"
               size="sm"
                :variant="
                  Filter.commonFilter ||
                  Filter.userFilter ||
                  Filter.enqStatusFilter ||
                  Filter.represntativeFilter ||
                  Filter.salePerFilter ||
                  Filter.clientFilter ||
                  Filter.slineFilter ||
                  Filter.branchFilter ||
                  Filter.porFilter ||
                  Filter.polFilter ||
                  Filter.fpodFilter ||
                  Filter.fclFilter ||
                  Filter.incotermFilter ||
                  Filter.enqNoFilter ||
                  Filter.transTypeFilter ||
                  Filter.enqDateFilter ||
                  Filter.saleDateFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                    ? 'outline-danger'
                    : 'outline-primary'
                "
                :class="'ml-4' + visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="collapse-4"
                @click="visible = !visible"
                >{{
                  Filter.commonFilter ||
                  Filter.userFilter ||
                  Filter.enqStatusFilter ||
                  Filter.represntativeFilter ||
                  Filter.salePerFilter ||
                  Filter.clientFilter ||
                  Filter.slineFilter ||
                  Filter.branchFilter ||
                  Filter.porFilter ||
                  Filter.polFilter ||
                  Filter.fpodFilter ||
                  Filter.fclFilter ||
                  Filter.incotermFilter ||
                  Filter.enqNoFilter ||
                  Filter.transTypeFilter ||
                  Filter.enqDateFilter ||
                  Filter.saleDateFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                    ? "Filter ON"
                    : "Filter OFF"
                }}</b-button
              >
              <b-button
                size="sm"
               style="font-size: 0.675rem"
                class="ml-1"
                @click="goToBookingREquest(null, 2)"
                variant="outline-info"
                >Booking Request</b-button
              >
            </b-nav-form>
          </b-navbar-nav>
        </b-row>
      </b-container>
      <div v-if="visible">
        <b-card mt-1>
          <b-collapse v-model="visible" id="collapse-2">
            <b-row>
              <b-col md="3">
                <label>Date</label>
                <date-range-picker
                  :always-show-calendars="showCal"
                  v-model="Filter.dateRange"
                  :startDate="startDate"
                  :endDate="endDate"
                  :locale-data="locale"
                  :disabled="Filter.DFlag ? true : false"
                  @update="getFreightEnquiryPriceingList"
                ></date-range-picker>
              </b-col>

              <b-col md="3"
                ><label>Enq Date</label
                ><b-form-input
                  type="date"
                  id="enqDateFilter-datepicker"
                  v-model="Filter.enqDateFilter"
                  placeholder="YYYY-MM-DD"
                  autocomplete="off"
                  @input="getFreightEnquiryPriceingList"
              /></b-col>
              <b-col md="3">
                <label>SOB Date</label>
                <b-form-input
                  type="date"
                  :formatter="capitalizeAll"
                  placeholder="Select SOB Date"
                  id="saleDateFilter"
                  name="saleDateFilter"
                  autocomplete="off"
                  v-model="Filter.saleDateFilter"
                  @input="getFreightEnquiryPriceingList"
                ></b-form-input>
              </b-col>
              <b-col md="3">
                <label>Incoterm</label>
                <model-list-select
                  :list="deliveryTermsName"
                  v-model="Filter.incotermFilter"
                  option-value="deliveryTermsVal"
                  option-text="deliveryTermsText"
                  placeholder="Select Incoterm"
                  @input="getFreightEnquiryPriceingList"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Status</label>
                <model-list-select
                  :list="filterStatusList"
                  v-model="Filter.enqStatusFilter"
                  option-value="StatusVal"
                  option-text="StatusText"
                  placeholder="Select Status"
                  @input="getFreightEnquiryPriceingList"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Representative</label>
                <model-list-select
                  :list="$store.getters['common/getAllUserList']"
                  v-model="Filter.represntativeFilter"
                  option-value="userId"
                  option-text="employeeName"
                  placeholder="Select Representative"
                  @input="getFreightEnquiryPriceingList"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Sales Person</label>
                <model-list-select
                  :list="$store.getters['common/getAllUserList']"
                  v-model="Filter.salePerFilter"
                  option-value="userId"
                  option-text="employeeName"
                  placeholder="Select Sales Person"
                  @input="getFreightEnquiryPriceingList"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Transport Type</label>
                <model-list-select
                  :list="TransportTypeList"
                  v-model="Filter.transTypeFilter"
                  option-value="StatusVal"
                  option-text="StatusText"
                  placeholder="Select Export / Import"
                  @input="getFreightEnquiryPriceingList"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Branch</label>
                <model-list-select
                  :list="$store.getters['common/getAllBranchList']"
                  id="branchfilter"
                  v-model="Filter.branchFilter"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="All"
                  @input="getFreightEnquiryPriceingList"
                  :isDisabled="
                    $sessionsStorage.get('designation') != 'Admin' ? true : false
                  "
                ></model-list-select>
              </b-col>

              <b-col md="3">
                <label>Client</label>
                <model-list-select
                  :list="$store.getters['common/getAllClientList']"
                  id="clientfilter"
                  v-model="Filter.clientFilter"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Client Name"
                  @input="getFreightEnquiryPriceingList"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Shipping Line</label>
                <model-list-select
                  :list="$store.getters['common/getAllShippingLineList']"
                  v-model="Filter.slineFilter"
                  option-value="shippingId"
                  option-text="shippingLine"
                  placeholder="Select Shipping Line"
                  :isDisabled="
                    $sessionsStorage.get('designation') != 'Admin' ? true : false
                  "
                  @input="getFreightEnquiryPriceingList"
                ></model-list-select>
              </b-col>

              <b-col md="3">
                <label>POR</label>
                <model-list-select
                  :list="
                    Filter.transTypeFilter == 'EXPORT'
                      ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
                        ]
                      : Filter.transTypeFilter == 'IMPORT'
                      ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
                        ]
                      : Filter.transTypeFilter == 'CRC'
                      ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                        ]
                      : $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
                        ]
                  "
                  v-model="Filter.porFilter"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select POR"
                  @input="getFreightEnquiryPriceingList"
                ></model-list-select>
              </b-col>

              <b-col md="3">
                <label>POL</label>
                <model-list-select
                  :list="
                    Filter.transTypeFilter == 'EXPORT'
                      ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
                        ]
                      : Filter.transTypeFilter == 'IMPORT'
                      ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
                        ]
                      : Filter.transTypeFilter == 'CRC'
                      ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                        ]
                      : $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
                        ]
                  "
                  v-model="Filter.polFilter"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select POL"
                  @input="getFreightEnquiryPriceingList"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>FPOD</label>
                <model-list-select
                  :list="
                    Filter.transTypeFilter == 'EXPORT'
                      ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineFPODDDList'
                        ]
                      : Filter.transTypeFilter == 'IMPORT'
                      ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPFPODDDList'
                        ]
                      : Filter.transTypeFilter == 'CRC'
                      ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                        ]
                      : $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineFPODDDList'
                        ]
                  "
                  v-model="Filter.fpodFilter"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select Final Port of Discharge"
                  @input="getFreightEnquiryPriceingList"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Container Type</label>
                <model-list-select
                  :list="$store.getters['common/getAllContainerTypeList']"
                  v-model="Filter.containerTypeFilter"
                  option-value="containerTypeId"
                  option-text="containerType"
                  placeholder="Select Container Type"
                  @input="getFreightEnquiryPriceingList"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>FCL/LCL</label>
                <model-list-select
                  :list="FCLLCLList"
                  v-model="Filter.fclFilter"
                  option-value="fcllclVal"
                  option-text="fcllclText"
                  placeholder="Select FCL / LCL"
                  @input="getFreightEnquiryPriceingList"
                ></model-list-select
              ></b-col>

              <b-col md="3">
                <label>Enq. No Filter</label>
                <b-form-input
                  type="text"
                  :formatter="capitalizeAll"
                  placeholder="Search Enq. No Filter"
                  id="enqNoFilter"
                  name="enqNoFilter"
                  autocomplete="off"
                  v-model="Filter.enqNoFilter"
                  @input="getFreightEnquiryPriceingList"
                ></b-form-input>
              </b-col>
              <b-col md="3">
                <label>Created/Updated By</label>
                <model-list-select
                  :list="$store.getters['common/getAllUserList']"
                  id="addedUserFilter"
                  @input="getFreightEnquiryPriceingList"
                  v-model="Filter.userFilter"
                  option-value="userId"
                  option-text="employeeName"
                  placeholder="Select Created User"
                ></model-list-select>
              </b-col>
              <b-col md="6">
                <label>Common Filter</label>
                <b-form-input
                  type="text"
                  :formatter="capitalizeAll"
                  placeholder="Search Common Filter"
                  id="CommonFilter"
                  name="CommonFilter"
                  autocomplete="off"
                  v-model="Filter.commonFilter"
                  @input="getFreightEnquiryPriceingList"
                ></b-form-input>
              </b-col>
              <b-col md="12" class="mt-2">
                <b-button
                  size="sm"
                  style="margin-left: auto"
                  class="ml-1 pull-right"
                  @click="clearFilter"
                  variant="outline-danger"
                  >Reset</b-button
                >
              </b-col>
            </b-row>
          </b-collapse>
        </b-card>
      </div>

      <div class="mt-3">
        <!-- Search Form Input Start-->
        <b-row>
          <b-col md="6" class="my-1">
            <!-- <b-form-group>
              <b-input-group>
                <b-form-input
                  :formatter="capitalizeAll"
                  @input="debounceSearch"
                  v-model="Filter.commonFilter"
                  placeholder="Type to Search Assignment"
                  ref="search"
                />

                <b-input-group-append class="mr-1">
                  <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group> -->
          </b-col>

          <b-col md="2"
            ><h5>
              <small v-if="isLoading == false">{{ FrtEnqList.length }} Entries</small>
            </h5>
          </b-col>
          <b-col md="2">
            <b-button
              class="pull-right mb-1"
              v-if="FrtEnqList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('checkJobPendency', 'Export As Excel')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2" class="my-1">
            <b-button @click="addRow" size="sm"
              ><i class="fa fa-plus-circle ml-1"></i
            ></b-button>
          </b-col>
          <b-col md="12" class="my-1">
            <div>
              <b-button @click="prevPage" :disabled="currentPage <= 1" size="sm"
                >Prev</b-button
              >
              <b-button
                v-for="page in pageCount"
                :key="page"
                @click="goToPage(page)"
                :disabled="page === currentPage"
                :class="'ml-1 mr-1' + (page === currentPage ? ' active-page' : '')"
              >
                {{ page }}
              </b-button>
              <b-button @click="nextPage" :disabled="currentPage >= pageCount" size="sm"
                >Next</b-button
              >
              Page {{ currentPage }} of {{ pageCount }}
            </div>
          </b-col>
        </b-row>
        <div class="col-md-12 row table-wrapper-scroll-x my-custom-scrollbar">
          <table class="table table-bordered table-background position-relative">
            <thead>
              <tr>
                <th>SN.</th>
                <th>Transport Type</th>
                <th>DATE</th>
                <th>INQUIRY NO.</th>
                <th>Branch</th>
                <th>SALES PERSON</th>
                <th>Shipping Line</th>
                <th>CLIENT</th>
                <th>INCOTERM</th>
                <th>POR</th>
                <th>POL</th>
                <th>DESTINATION</th>
                <th>FCL/LCL</th>
                <th>CARGO WEIGHT</th>
                <th>EQUIPMENT</th>
                <th>PDA</th>
                <th>PRICING REP.</th>
                <th>STATUS</th>
                <th>REMARKS</th>
                <th>Tentative Sail Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in paginatedRows" :key="row.id">
                <td>
                  <span>{{ index + 1 + (currentPage - 1) * perPage }}</span>
                </td>
                <td>
                  {{ row.frt_enq_transport_type }}
                  <model-list-select
                    :isDisabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :list="TransportTypeList"
                    id="frt_enq_transport_type"
                    v-model="row.frt_enq_transport_type"
                    option-value="StatusVal"
                    option-text="StatusText"
                    placeholder="Select Transport Type"
                  ></model-list-select>
                  <span
                    class="error"
                    v-if="row.frt_enq_transport_type_err ? true : false"
                    >{{ row.frt_enq_transport_type_err }}</span
                  >
                </td>
                <td>
                  <div class="input-container">
                    <date-picker
                      :disabled="true"
                      :style="{ width: '200px' }"
                      :format="selectDateFormat"
                      lang="en"
                      name="frt_enq_date"
                      id="frt_enq_date"
                      v-model="row.frt_enq_date"
                      :not-before="calculateMinDate()"
                    ></date-picker>
                    <span class="error" v-if="row.frt_enq_date_err ? true : false">{{
                      row.frt_enq_date_err
                    }}</span>
                  </div>
                </td>
                <td>
                  <div class="input-container">
                    <b-form-input
                      :disabled="true"
                      :style="{ width: '200px' }"
                      :formatter="capitalizeAll"
                      v-model="row.frt_enq_no"
                      type="text"
                      placeholder="Enter Enquiry No "
                    ></b-form-input>
                    <span class="error" v-if="row.frt_enq_no_err ? true : false">{{
                      row.frt_enq_no_err
                    }}</span>
                  </div>
                </td>
                <td>
                  <model-list-select
                    :isDisabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :list="$store.getters['common/getAllBranchList']"
                    id="fk_branch_id"
                    v-model="row.fk_branch_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Branch Name"
                  ></model-list-select>
                  <span class="error" v-if="row.fk_branch_id_err ? true : false">{{
                    row.fk_branch_id_err
                  }}</span>
                </td>
                <td>
                  <model-list-select
                    :isDisabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :list="$store.getters['common/getAllUserList']"
                    id="addedUserFilter"
                    v-model="row.fk_sales_person_id"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Sales Person"
                  ></model-list-select>
                  <span class="error" v-if="row.fk_sales_person_id_err ? true : false">{{
                    row.fk_sales_person_id_err
                  }}</span>
                </td>
                <td>
                  <model-list-select
                    :isDisabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :list="$store.getters['common/getAllShippingLineList']"
                    v-model="row.fk_sline_id"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                  ></model-list-select>
                  <span class="error" v-if="row.fk_sline_id_err ? true : false">{{
                    row.fk_sline_id_err
                  }}</span>
                </td>
                <td>
                  <b-form-radio-group
                    v-model="row.client_type"
                    :options="clientTypeList"
                    class="mb-3"
                    value-field="cVal"
                    text-field="cText"
                  ></b-form-radio-group>
                  <model-list-select
                    v-if="row.client_type === 'Normal'"
                    :isDisabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :list="$store.getters['common/getAllClientList']"
                    id="clientNamenew"
                    v-model="row.fk_client_id"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Client Name"
                  ></model-list-select>
                  <span class="error" v-if="row.fk_client_id_err ? true : false">{{
                    row.fk_client_id_err
                  }}</span>
                  <!-- <model-list-select
                    :isDisabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: row.client_type === 'Normal' ? '200px' : '0', opacity: row.client_type === 'Normal' ? '1' : '0', overflow: 'hidden' }"
                    :list="$store.getters['common/getAllClientList']"
                    id="clientNamenew"
                    v-model="row.fk_client_id"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Client Name"
                  >
                </model-list-select> -->
                  <span class="error" v-if="row.fk_client_id_err ? true : false">{{
                    row.fk_client_id_err
                  }}</span>
                  <!-- {{ row.fk_client_id_err }} -->
                  <b-form-input
                    :style="{ width: '200px' }"
                    type="text"
                    v-model="row.frt_enq_general_client"
                    v-if="row.client_type === 'General'"
                  />
                  <!-- {{ row.client_type }} -->
                </td>
                <td>
                  <model-list-select
                    :isDisabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :list="deliveryTermsName"
                    id="frt_enq_incoterm"
                    v-model="row.frt_enq_incoterm"
                    option-value="deliveryTermsVal"
                    option-text="deliveryTermsText"
                    placeholder="Select Incoterm"
                  ></model-list-select>
                  <span class="error" v-if="row.frt_enq_incoterm_err ? true : false">{{
                    row.frt_enq_incoterm_err
                  }}</span>
                </td>
                <td>
                  <multi-select
                    :isDisabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :options="
                      row.frt_enq_transport_type == 'EXPORT'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
                          ]
                        : row.frt_enq_transport_type == 'IMPORT'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
                          ]
                        : row.frt_enq_transport_type == 'CRC'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                          ]
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
                          ]
                    "
                    :selected-options="row.fk_por_id_items"
                    v-model="row.fk_por_id"
                    placeholder="Select POL"
                    :multiple="true"
                    @select="SelectPOR(row, index, $event)"
                  ></multi-select>
                  <span class="error" v-if="row.fk_por_id_err ? true : false">{{
                    row.fk_por_id_err
                  }}</span>
                </td>
                <td>
                  <multi-select
                    :isDisabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :options="
                      row.frt_enq_transport_type == 'EXPORT'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
                          ]
                        : row.frt_enq_transport_type == 'IMPORT'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
                          ]
                        : row.frt_enq_transport_type == 'CRC'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                          ]
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
                          ]
                    "
                    :selected-options="row.fk_pol_id_items"
                    v-model="row.fk_pol_id"
                    placeholder="Select POL"
                    :multiple="true"
                    @select="SelectPOL(row, index, $event)"
                  ></multi-select
                  ><span class="error" v-if="row.fk_por_id_err ? true : false">{{
                    row.fk_por_id_err
                  }}</span>
                </td>
                <td>
                  <multi-select
                    :isDisabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :options="
                      row.frt_enq_transport_type == 'EXPORT'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineFPODDDList'
                          ]
                        : row.frt_enq_transport_type == 'IMPORT'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPFPODDDList'
                          ]
                        : row.frt_enq_transport_type == 'CRC'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                          ]
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineFPODDDList'
                          ]
                    "
                    :selected-options="row.fk_fpod_id_items"
                    v-model="row.fk_fpod_id"
                    placeholder="Select FPOD"
                    :multiple="true"
                    @select="SelectFPOD(row, index, $event)"
                  ></multi-select>
                  <span class="error" v-if="row.fk_fpod_id_err ? true : false">{{
                    row.fk_fpod_id_err
                  }}</span>
                </td>
                <td>
                  <model-list-select
                    :isDisabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :list="FCLLCLList"
                    id="frt_enq_incoterm"
                    v-model="row.frt_enq_fcl_lcl"
                    option-value="fcllclVal"
                    option-text="fcllclText"
                    placeholder="Select FCL/LCL/AIR"
                  ></model-list-select>
                  <span class="error" v-if="row.frt_enq_fcl_lcl_err ? true : false">{{
                    row.frt_enq_fcl_lcl_err
                  }}</span>
                </td>
                <td>
                  <b-form-input
                    :disabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :formatter="capitalizeAll"
                    v-model="row.frt_enq_cargo_weight"
                    type="number"
                    placeholder="Enter Cargo Weight "
                  ></b-form-input>
                  <span
                    class="error"
                    v-if="row.frt_enq_cargo_weight_err ? true : false"
                    >{{ row.frt_enq_cargo_weight_err }}</span
                  >
                </td>
                <td>
                  <multi-select
                    :isDisabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :options="$store.getters['common/getAllContainerTypeList']"
                    :selected-options="row.frt_enq_equipment_items"
                    v-model="row.frt_enq_equipment"
                    placeholder="Select Equipment"
                    :multiple="true"
                    @select="SelectEquipment(row, index, $event)"
                  ></multi-select>
                  <span v-if="row.frt_enq_id <= 188">{{ row.frt_enq_equipment }}</span>
                </td>
                <td>
                  <b-form-input
                    :disabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :formatter="capitalizeAll"
                    v-model="row.frt_enq_pda"
                    type="text"
                    placeholder="Enter PDA"
                  ></b-form-input>
                  <span class="error" v-if="row.frt_enq_pda_err ? true : false">{{
                    row.frt_enq_pda_err
                  }}</span>
                </td>
                <td>
                  <model-list-select
                    :isDisabled="row.frt_enq_id > 0 ? true : false"
                    :style="{ width: '200px' }"
                    :list="$store.getters['common/getAllUserList']"
                    id="addedUserFilter"
                    v-model="row.frt_enq_priceing_rep"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Priceing Rep."
                  ></model-list-select
                  ><span
                    class="error"
                    v-if="row.frt_enq_priceing_rep_err ? true : false"
                    >{{ row.frt_enq_priceing_rep_err }}</span
                  >
                </td>
                <td>
                  <model-list-select
                    :style="{ width: '200px' }"
                    :list="StatusList"
                    id="frt_enq_status"
                    v-model="row.frt_enq_status"
                    option-value="StatusVal"
                    option-text="StatusText"
                    placeholder="Select Status"
                  ></model-list-select>
                  <b-button
                    v-if="row.frt_enq_id > 0 && row.frt_enq_status == 'QUOTED'"
                    size="sm"
                    style="font-size: 0.675rem"
                    class="ml-1 mt-1"
                    @click="goToBookingREquest(row, 1)"
                    variant="outline-info"
                    >Booking Request</b-button
                  >
                  <span class="error" v-if="row.frt_enq_status_err ? true : false">{{
                    row.frt_enq_status_err
                  }}</span>
                </td>
                <td>
                  <b-textarea
                    :style="{ width: '200px' }"
                    :formatter="capitalizeAll"
                    v-model="row.frt_enq_remarks"
                    :key="index"
                    rows="3"
                    type="text"
                    placeholder="Enter Remark"
                  ></b-textarea>
                  <span class="error" v-if="row.frt_enq_remarks_err ? true : false">{{
                    row.frt_enq_remarks_err
                  }}</span>
                </td>
                <td>
                  <div class="input-container">
                    <date-picker
                      :style="{ width: '200px' }"
                      :format="selectDateFormat"
                      lang="en"
                      name="frt_enq_tentative_sale_date"
                      id="frt_enq_tentative_sale_date"
                      placeholder="Enter Tentative Sail Date"
                      v-model="row.frt_enq_tentative_sale_date"
                      :not-before="calculateMinDate()"
                    ></date-picker>
                    <span
                      class="error"
                      v-if="row.frt_enq_tentative_sale_date_err ? true : false"
                      >{{ row.frt_enq_tentative_sale_date_err }}</span
                    >
                  </div>
                </td>

                <td>
                  <span :style="{ display: 'none' }">{{ index }}</span>
                  <EnqCloseStatus
                    v-if="row.frt_enq_id <= 188"
                    :PMC_title="'Update Enquiry ' + row.frt_enq_no"
                    :PMC_ENQID="row.frt_enq_id"
                    :PMC_ENQNO="row.frt_enq_no"
                    :PMC_ENQDATE="row.frt_enq_date"
                    :PMC_ENQREMARK="row.frt_enq_remarks"
                    :PMC_ENQSTATUS="row.frt_enq_status"
                    :PMC_ENQTENTATIVESOB="row.frt_enq_tentative_sale_date"
                  />
                  <b-button
                    variant="primary"
                    @click="saveEnquiry(row, index, FrtEnqList[index])"
                    id="saveEnquiry"
                    >{{
                      row.frt_enq_id && row.frt_enq_id > 0 ? "Update" : "Save"
                    }}</b-button
                  >
                  <span v-if="row.createdBy">Created By : {{ row.createdBy }}</span
                  ><br />
                  <span v-if="row.updatedBy">Updated By : {{ row.updatedBy }}</span
                  ><br />
                  <b-button
                    v-if="!row.frt_enq_id"
                    class="btn btn-sm btn-danger"
                    @click="removeRow(index)"
                    >Remove</b-button
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <b-button @click="prevPage" :disabled="currentPage <= 1" size="sm"
              >Prev</b-button
            >
            <b-button
              v-for="page in pageCount"
              :key="page"
              @click="goToPage(page)"
              :disabled="page === currentPage"
              :class="'ml-1 mr-1' + (page === currentPage ? ' active-page' : '')"
            >
              {{ page }}
            </b-button>
            <b-button @click="nextPage" :disabled="currentPage >= pageCount" size="sm"
              >Next</b-button
            >
            Page {{ currentPage }} of {{ pageCount }}
          </div>
        </div>
      </div>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters.js";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection.js";
import MasterService from "../../services/MasterService.js";
import DateRangePicker from "vue2-daterange-picker";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";

import Multiselect from "vue-multiselect";
import CustomLoader from "../common/customLoader.vue";
import EnqCloseStatus from "../common/enqCloseStatus.vue";
export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", this.$route.path);
      if (globalPermissionStatus("Enq. For Pricing")) {
        if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
          this.getFreightEnquiryPriceingList("Normal", "0", "0", "1", "1");
        } else {
          this.getFreightEnquiryPriceingList("Normal", "0", "0", "1", "1");
        }
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({
          itemCode: "ContainerTypeList",
        })
      );
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      );
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      );
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({
          itemCode: "ClientList",
        })
      );
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({
          itemCode: "ShippingLineList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEnginePODDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEnginePODDDList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineFPODDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEngineFPODDDList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEnginePOLDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEnginePOLDDList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEnginePORDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEnginePORDDList",
        })
      );

      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPORDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEngineIMPPORDDList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPOLDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEngineIMPPOLDDList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPODDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEngineIMPPODDDList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPFPODDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEngineIMPFPODDDList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineCrossCountryLocationDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEngineCrossCountryDDList",
        })
      );
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      visible: true,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      selectDateFormat,
      TransportTypeList: [
        {
          StatusVal: "EXPORT",
          StatusText: "EXPORT",
        },
        {
          StatusVal: "IMPORT",
          StatusText: "IMPORT",
        },
        {
          StatusVal: "CRC",
          StatusText: "CROSS COUNTRY",
        },
      ],
      filterStatusList: [
        {
          StatusVal: "All",
          StatusText: "All",
        },
        {
          StatusVal: "QUOTED",
          StatusText: "QUOTED",
        },
        {
          StatusVal: "REQUESTED",
          StatusText: "REQUESTED",
        },
        {
          StatusVal: "CLOSED",
          StatusText: "CLOSED",
        },
        {
          StatusVal: "QUOTED ON ZIM",
          StatusText: "QUOTED ON ZIM",
        },
      ],
      StatusList: [
        {
          StatusVal: "QUOTED",
          StatusText: "QUOTED",
        },
        {
          StatusVal: "REQUESTED",
          StatusText: "REQUESTED",
        },
        {
          StatusVal: "CLOSED",
          StatusText: "CLOSED",
        },
        {
          StatusVal: "QUOTED ON ZIM",
          StatusText: "QUOTED ON ZIM",
        },
      ],
      FCLLCLList: [
        {
          fcllclVal: "FCL",
          fcllclText: "FCL",
        },
        {
          fcllclVal: "LCL",
          fcllclText: "LCL",
        },
        {
          fcllclVal: "AIR",
          fcllclText: "AIR",
        },
      ],
      deliveryTermsName: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "EXWORKS",
        },
        {
          deliveryTermsVal: "FOB",
          deliveryTermsText: "FOB",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDU",
          deliveryTermsText: "DDU",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
      ],
      isLoading: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 25,
      pageOptions: [100, 200, 300],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      docURL: URL_BASE_DOC,
      ExcelBtnName: "Export As Excel",
      activeButtonBranch:
        this.$sessionsStorage.get("branchclientPre") == "1" ? true : false,
      activeUserPreference: this.$sessionsStorage.get("user_pre") === "1" ? true : false,

      Filter: {
        userFilter: this.$sessionsStorage.get("userId"),
      },

      columnMain: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A",
        },
        {
          key: "frt_enq_transport_type",
          mainkey: "frt_enq_transport_type",
          label: "Transport Type",
          sortable: true,
          sortDirection: "ASC",
          table: "B",
        },
        {
          key: "frt_enq_date",
          mainkey: "frt_enq_date",
          label: "DATE",
          sortable: true,
          sortDirection: "ASC",
          table: "B",
        },
        {
          key: "frt_enq_no",
          mainkey: "frt_enq_no",
          label: "INQUIRY NO.",
          sortable: true,
          sortDirection: "ASC",
          table: "C",
        },
        {
          key: "fk_branch_id",
          mainkey: "fk_branch_id",
          label: "Branch",
          sortable: true,
          sortDirection: "ASC",
          table: "D",
        },
        {
          key: "fk_sales_person_id",
          mainkey: "fk_sales_person_id",
          label: "SALES PERSON",
          sortable: true,
          sortDirection: "ASC",
          table: "E",
        },
        {
          key: "fk_sline_id",
          lmainkey: "fk_sline_id",
          label: "Shipping Line",
          sortable: true,
          sortDirection: "ASC",
          table: "F",
        },
        {
          key: "fk_client_id",
          lmainkey: "fk_client_id",
          label: "CLIENT",
          sortable: true,
          sortDirection: "ASC",
          table: "G",
        },
        {
          key: "frt_enq_incoterm",
          mainkey: "frt_enq_incoterm",
          label: "INCOTERM",
          sortable: true,
          sortDirection: "ASC",
          table: "H",
        },
        {
          key: "fk_por_id",
          lmainkey: "fk_por_id",
          label: "POR",
          sortable: true,
          sortDirection: "ASC",
          table: "I",
        },
        {
          key: "fk_pol_id",
          mainkey: "fk_pol_id",
          label: "POL",
          sortable: true,
          sortDirection: "ASC",
          table: "J",
        },
        {
          key: "fk_fpod_id",
          mainkey: "fk_fpod_id",
          label: "DESTINATION",
          sortable: true,
          sortDirection: "ASC",
          table: "K",
        },
        {
          key: "frt_enq_fcl_lcl",
          mainkey: "frt_enq_fcl_lcl",
          label: "FCL/LCL",
          sortable: true,
          sortDirection: "ASC",
          table: "L",
        },
        {
          key: "frt_enq_cargo_weight",
          mainkey: "frt_enq_cargo_weight",
          label: "CARGO WEIGHT",
          sortable: true,
          sortDirection: "ASC",
          table: "M",
        },
        {
          key: "frt_enq_equipment",
          mainkey: "frt_enq_equipment",
          label: "EQUIPMENT",
          sortable: true,
          sortDirection: "ASC",
          table: "N",
        },
        {
          key: "frt_enq_pda",
          mainkey: "frt_enq_pda",
          label: "PDA",
          sortable: true,
          sortDirection: "ASC",
          table: "N",
        },
        {
          key: "frt_enq_priceing_rep",
          mainkey: "frt_enq_priceing_rep",
          label: "PRICING REP.",
          sortable: true,
          sortDirection: "ASC",
          table: "O",
        },
        {
          key: "frt_enq_status",
          mainkey: "frt_enq_status",
          label: "STATUS",
          sortable: true,
          sortDirection: "ASC",
          table: "P",
        },

        {
          key: "frt_enq_remarks",
          mainkey: "frt_enq_remarks",
          label: "REMARKS",
          sortable: true,
          sortDirection: "ASC",
          table: "Q",
        },
        {
          key: "frt_enq_tentative_sale_date",
          mainkey: "frt_enq_tentative_sale_date",
          label: "Tentative Sail Date",
          sortable: true,
          sortDirection: "ASC",
          table: "R",
        },
        {
          key: "frt_enq_action",
          mainkey: "frt_enq_action",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "S",
        },
      ],
      frt_enq_equipment_items: [],
      freightEnqArr: [],
      FrtEnqList: [],
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      error_count: 0,
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      Filter: {
        commonFilter: "",
        userFilter: "",
        enqStatusFilter: "REQUESTED",
        represntativeFilter: "",
        salePerFilter: "",
        clientFilter: "",
        slineFilter: "",
        branchFilter: "",
        porFilter: "",
        polFilter: "",
        fpodFilter: "",
        containerTypeFilter: "",
        fclFilter: "",
        incotermFilter: "",
        enqNoFilter: "",
        transTypeFilter: "",
        enqDateFilter: "",
        saleDateFilter: "",

        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      clientTypeList: [
        {
          cVal: "Normal",
          cText: "Normal",
        },
        {
          cVal: "General",
          cText: "General",
        },
      ],
      pageSize: 25,
      currentPage: 1,
      selected: "normal",
    };
  },
  mounted() {},
  filters: {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    MultiSelect,
    Multiselect,
    FilterAgencyModal,
    FilterCBModal,
    CustomLoader,
    EnqCloseStatus,
  },
  created() {
    eventBus.$on("enqApprovalComp", (enqApprovalComp) => {
      if (enqApprovalComp.frt_enq_id > 1) {
        this.getFreightEnquiryPriceingList("Normal", "0", "0", "1", "1");
        this.$forceUpdate();
      }
    });
  },
  computed: {
    pageCount() {
      return Math.ceil(this.FrtEnqList.length / this.pageSize);
    },
    paginatedRows() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.FrtEnqList.slice(start, start + this.pageSize);
    },
  },
  methods: {
    clearFilter() {},
    addRow() {
      let obj = {
        frt_enq_id: "",
        frt_enq_date: new Date().toISOString().substr(0, 10),
        frt_enq_no: "",
        fk_branch_id: "",
        fk_sales_person_id: "",
        fk_sline_id: "",
        fk_client_id: "",
        frt_enq_incoterm: "",
        client_type: "Normal",
        fk_por_id_items: [],
        fk_por_id: "",
        fk_pol_id_items: [],
        fk_pol_id: "",
        fk_fpod_id_items: [],
        fk_fpod_id: "",
        frt_enq_fcl_lcl: "",
        frt_enq_cargo_weight: "",
        frt_enq_equipment: "",
        frt_enq_equipment_items: [],
        frt_enq_pda: "",
        frt_enq_priceing_rep: "",
        frt_enq_status: "REQUESTED",
        frt_enq_remarks: "",
        frt_enq_tentative_sale_date: "",
        frt_enq_transport_type: "EXPORT",

        frt_enq_date_err: "",
        frt_enq_no_err: "",
        fk_branch_id_err: "",
        fk_sales_person_id_err: "",
        fk_sline_id_err: "",
        fk_client_id_err: "",
        frt_enq_incoterm_err: "",
        fk_por_id_err: "",
        fk_pol_id_err: "",
        fk_fpod_id_err: "",
        frt_enq_fcl_lcl_err: "",
        frt_enq_cargo_weight_err: "",
        frt_enq_equipment_err: "",
        frt_enq_pda_err: "",
        frt_enq_priceing_rep_err: "",
        frt_enq_status_err: "",
        frt_enq_remarks_err: "",
        frt_enq_tentative_sale_date_err: "",
        frt_enq_transport_type_err: "",
      };
      this.FrtEnqList.unshift(obj);
    },
    removeRow(index) {
      const realIndex = (this.currentPage - 1) * this.pageSize + index;
      this.FrtEnqList.splice(realIndex, 1);
    },
    nextPage() {
      if (this.currentPage < this.pageCount) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    goToPage(page) {
      this.currentPage = page;
    },

    SelectEquipment(item, index, frt_enq_equipment_items) {
      item.frt_enq_equipment_items = frt_enq_equipment_items;
      item.frt_enq_equipment = item.frt_enq_equipment_items;
    },
    SelectPOR(item, index, fk_por_id_items) {
      item.fk_por_id_items = fk_por_id_items;
      item.fk_por_id = item.fk_por_id_items;
    },
    SelectPOL(item, index, fk_pol_id_items) {
      item.fk_pol_id_items = fk_pol_id_items;
      item.fk_pol_id = item.fk_pol_id_items;
    },
    SelectFPOD(item, index, fk_fpod_id_items) {
      item.fk_fpod_id_items = fk_fpod_id_items;
      item.fk_fpod_id = item.fk_fpod_id_items;
    },
    saveEnquiry(item, index, item_index) {
      this.error_count = 0;
      console.log("Success ENquiry item_index=>", item_index);
      this.validateEnquiryDetail(item, index, item_index);
      console.log(
        "saveEnquiry=>",
        item,
        "index",
        index,
        "error_count=>",
        this.error_count
      );
      if (this.error_count > 0) {
        console.log("Failed ENquiry");
      } else {
        let fk_por_id = null;
        let fk_pol_id = null;
        let fk_fpod_id = null;
        let frt_enq_equipment = null;
        let fk_por_id_label = null;
        let fk_pol_id_label = null;
        let fk_fpod_id_label = null;
        let frt_enq_equipment_label = null;
        if (item.fk_pol_id_items.length > 0) {
          item.fk_pol_id_items.forEach((element) => {
            if (!fk_pol_id) {
              fk_pol_id = element.value;
              fk_pol_id_label = element.text;
            } else {
              fk_pol_id = fk_pol_id + "," + element.value;
              fk_pol_id_label = fk_pol_id_label + "," + element.text;
            }
          });
        }
        if (item.fk_por_id_items.length > 0) {
          item.fk_por_id_items.forEach((element) => {
            if (!fk_por_id) {
              fk_por_id = element.value;
              fk_por_id_label = element.text;
            } else {
              fk_por_id = fk_por_id + "," + element.value;
              fk_por_id_label = fk_por_id_label + "," + element.text;
            }
          });
        }

        if (item.fk_fpod_id_items.length > 0) {
          item.fk_fpod_id_items.forEach((element) => {
            if (!fk_fpod_id) {
              fk_fpod_id = element.value;
              fk_fpod_id_label = element.text;
            } else {
              fk_fpod_id = fk_fpod_id + "," + element.value;
              fk_fpod_id_label = fk_fpod_id_label + "," + element.text;
            }
          });
        }
        if (item.frt_enq_equipment_items.length > 0) {
          item.frt_enq_equipment_items.forEach((element) => {
            if (!frt_enq_equipment) {
              frt_enq_equipment = element.value;
              frt_enq_equipment_label = element.text;
            } else {
              frt_enq_equipment = frt_enq_equipment + "," + element.value;
              frt_enq_equipment_label = frt_enq_equipment_label + "," + element.text;
            }
          });
        }
        item.fk_fpod_id = fk_fpod_id;
        item.fk_por_id = fk_por_id;
        item.fk_pol_id = fk_pol_id;
        item.frt_enq_equipment = frt_enq_equipment;

        item.fk_fpod_id_label = fk_fpod_id_label;
        item.fk_por_id_label = fk_por_id_label;
        item.fk_pol_id_label = fk_pol_id_label;
        item.frt_enq_equipment_label = frt_enq_equipment_label;
        let payload = {
          itemCode: "saveFreightEnquiry",
          itemDetails: item,
        };
        // console.log("payload=>", payload);
        // return false;

        MasterService.getFreightEnqPriceing(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log();
            if (status == 200 && data.find == 1) {
              this.alert.content = data.MSG;
              this.$refs["addPop"].open();
              this.getFreightEnquiryPriceingList("Normal", "0", "0", "1", "1");
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on saveFreightEnquiry Error: ", error);
          });

        console.log("Success ENquiry");
      }
    },
    validateEnquiryDetail(item, index, item_index) {
      Object.keys(this.FrtEnqList[index]).map((obj_item) => {
        if (obj_item.indexOf("_err") >= 0) {
          this.FrtEnqList[index][obj_item] = "";
        }
      });
      console.log("this.FrtEnqList[index]=>", this.FrtEnqList[index], this.FrtEnqList);
      if (!this.FrtEnqList[index].frt_enq_transport_type) {
        this.FrtEnqList[index].frt_enq_transport_type_err =
          "Transport Type Fields is Required!";
        this.error_count += 1;
      } else {
        this.FrtEnqList[index].frt_enq_transport_type_err = "";
      }
      if (!this.FrtEnqList[index].frt_enq_date) {
        this.FrtEnqList[index].frt_enq_date_err = "Enquiry Date Fields is Required!";
        this.error_count += 1;
      } else {
        this.FrtEnqList[index].frt_enq_date_err = "";
      }

      // if (!this.FrtEnqList[index].frt_enq_no) {
      //   this.FrtEnqList[index].frt_enq_no_err = "Enquiry No Fields is Required!";
      //   this.error_count += 1;
      // } else {
      //   this.FrtEnqList[index].frt_enq_no_err = "";
      // }

      if (!this.FrtEnqList[index].fk_branch_id) {
        this.FrtEnqList[index].fk_branch_id_err = "Branch Name Fields is Required!";
        this.error_count += 1;
      } else {
        this.FrtEnqList[index].fk_branch_id_err = "";
      }

      if (!this.FrtEnqList[index].fk_sales_person_id) {
        this.FrtEnqList[index].fk_sales_person_id_err =
          "Sales Person Fields is Required!";
        this.error_count += 1;
      } else {
        this.FrtEnqList[index].fk_sales_person_id_err = "";
      }

      if (!this.FrtEnqList[index].fk_sline_id) {
        this.FrtEnqList[index].fk_sline_id_err = "Sline Name Fields is Required!";
        this.error_count += 1;
      } else {
        this.FrtEnqList[index].fk_sline_id_err = "";
      }

      if (this.FrtEnqList[index].client_type == "Normal") {
        //changed by himanshu

        if (!this.FrtEnqList[index].fk_client_id) {
          this.FrtEnqList[index].fk_client_id_err = "Client Name Fields is Required!";
          this.error_count += 1;
        } else {
          this.FrtEnqList[index].fk_client_id_err = "";
        }
      }

      if (!this.FrtEnqList[index].frt_enq_incoterm) {
        this.FrtEnqList[index].frt_enq_incoterm_err = "Incoterm Fields is Required!";
        this.error_count += 1;
      } else {
        this.FrtEnqList[index].frt_enq_incoterm_err = "";
      }

      // if (!this.FrtEnqList[index].fk_por_id) {
      //   this.FrtEnqList[index].fk_por_id_err = "POR Fields is Required!";
      //   this.error_count += 1;
      // } else {
      //   this.FrtEnqList[index].fk_por_id_err = "";
      // }

      // if (!this.FrtEnqList[index].fk_pol_id) {
      //   this.FrtEnqList[index].fk_pol_id_err = "POL Fields is Required!";
      //   this.error_count += 1;
      // } else {
      //   this.FrtEnqList[index].fk_pol_id_err = "";
      // }

      // if (!this.FrtEnqList[index].fk_fpod_id) {
      //   this.FrtEnqList[index].fk_fpod_id_err = "Destination Fields is Required!";
      //   this.error_count += 1;
      // } else {
      //   this.FrtEnqList[index].fk_fpod_id_err = "";
      // }

      if (!this.FrtEnqList[index].frt_enq_fcl_lcl) {
        this.FrtEnqList[index].frt_enq_fcl_lcl_err = "FCL/LCL Fields is Required!";
        this.error_count += 1;
      } else {
        this.FrtEnqList[index].frt_enq_fcl_lcl_err = "";
      }

      if (!this.FrtEnqList[index].frt_enq_cargo_weight) {
        this.FrtEnqList[index].frt_enq_cargo_weight_err =
          "Cargo Weight Fields is Required!";
        this.error_count += 1;
      } else {
        this.FrtEnqList[index].frt_enq_cargo_weight_err = "";
      }

      // if (!this.FrtEnqList[index].frt_enq_equipment) {
      //   this.FrtEnqList[index].frt_enq_equipment_err = "Equipment Fields is Required!";
      //   this.error_count += 1;
      // } else {
      //   this.FrtEnqList[index].frt_enq_equipment_err = "";
      // }

      if (!this.FrtEnqList[index].frt_enq_pda) {
        this.FrtEnqList[index].frt_enq_pda_err = "PDA Fields is Required!";
        this.error_count += 1;
      } else {
        this.FrtEnqList[index].frt_enq_pda_err = "";
      }

      if (!this.FrtEnqList[index].frt_enq_priceing_rep) {
        this.FrtEnqList[index].frt_enq_priceing_rep_err =
          "Priceing Rep. Fields is Required!";
        this.error_count += 1;
      } else {
        this.FrtEnqList[index].frt_enq_priceing_rep_err = "";
      }

      if (!this.FrtEnqList[index].frt_enq_status) {
        this.FrtEnqList[index].frt_enq_status_err = "Status Fields is Required!";
        this.error_count += 1;
      } else {
        this.FrtEnqList[index].frt_enq_status_err = "";
      }
    },
    calculateMinDate() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const minDate = new Date(today);
      minDate.setMonth(minDate.getMonth());
      return minDate.setDate(now.getDate());
    },
    goToBookingREquest(row, type) {
      this.$sessionsStorage.set("is_duplicate", "0");
      this.$sessionsStorage.set("booking_resp_frt_enq_id", 0);
      this.$sessionsStorage.set("freight_enq_no", "");
      this.$sessionsStorage.set("is_new_book_resp", type);
      if (row){
        this.$sessionsStorage.set("freight_enq_no", row.frt_enq_no);
      }

      if (row && row.frt_enq_id) {
        this.$sessionsStorage.set("booking_resp_frt_enq_id", row.frt_enq_id);
      }
      this.$sessionsStorage.set("booking_resp_edit_type", 'Add');
      this.$router.push({
        path: "/pricing/upsert-new-booking-resp/1/0",
      });
    },
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getFreightEnquiryPriceingList("Excell", "0", "0", "1", "1");
    },
    getFreightEnquiryPriceingList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.FrtEnqList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getFreightEnquiryList",
        type: type,
        Filter: this.Filter,
      };

      MasterService.getFreightEnqPriceing(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.FrtEnqList.length > 0) {
                this.FrtEnqList = data.FrtEnqList;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.FrtEnqList.length > 0) {
                this.FrtEnqList = data.FrtEnqList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on FrtEnqList Error: ", error);
        });
    },

    filterClear() {
      this.filter = "";
      this.getFreightEnquiryPriceingList("Normal", "0", "0", "1", "1");
    },

    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.currentPage = 1;
    },
    goBack() {
      window.history.go(-1);
    },
    clearTimeout() {},

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getFreightEnquiryPriceingList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
  },
};
</script>

<style scoped>
.radio-group {
  display: flex;
  align-items: center; /* Align items vertically */
}
.radio-group > * {
  margin-right: 10px; /* Add spacing between elements */
}
table {
  width: 100%;
  border-collapse: collapse;
  height: 100%;
}

th,
td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}
th {
  background-color: #007bff; /* Bootstrap's primary blue color */
  color: white; /* Set text color to white for better readability */
}

.active-page {
  font-weight: bold;
  text-decoration: underline;
  color: #ffffff;
  background-color: #007bff;
}
input {
  width: 100%;
  box-sizing: border-box;
}
.table-background thead {
  background-color: #305496;
  border-color: lightgrey;
  border-bottom-style: none;
  border-style: solid;
  border-width: 2px;
  height: 40px;
  position: sticky;
  top: 0;
  font-size: 11px;
}
.my-custom-scrollbar {
  position: relative;
  /* height: 550px; */
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 1940px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
.md-body-1,
.pendencyBody {
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.01em;
  line-height: 20px;
}

.table-background > tbody {
  font-size: 11px;
}

.table-background > thead {
  color: white;
}
.mx-datepicker-popup {
  position: initial;
}
.input-container {
  width: 100%;
}
.table-background input[type="text"],
.table-background input[type="number"],
.table-background select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// freightEnquiryNew.vue?0b9d1189